module.exports = __WEBPACK_EXTERNAL_MODULE_279__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/utils/AGALMiniAssembler","root":["openfl","utils","AGALMiniAssembler"],"commonjs":"openfl/utils/AGALMiniAssembler","commonjs2":"openfl/utils/AGALMiniAssembler"}
// module id = 279
// module chunks = 0